<template>
  <upload-files
    v-if="isShow"
    :max="content.allowPhotoNum"
    :min="content.allowMinPhotoNum"
    :allow-types="content.allowFileTypes"
    v-model="content.fileList"
  />
</template>

<script>
import UploadFiles from '@/questions/components/UploadFiles'

export default {
  name: 'AdapterUploadFiles',
  components: { UploadFiles },
  props: {
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isShow() {
      return !!this.content.allowPhotoNum
    }
  }
}
</script>
